(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet-new-payment-flow.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet-new-payment-flow.js');
"use strict";


const logger = new svs.core.log.Logger('svs.sport.QuickplayModal.placeBetNewPayment');
const {
  getDisplayName,
  resolveITSProductId
} = svs.utils.products;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  createMarketplacePaymentFlow
} = svs.components.wagerPaymentFlow.marketplaceFlow;
const {
  Bet
} = svs.components.payment.createWager.bet;
const {
  createWager
} = svs.components.payment.createWager;
const {
  oneXTwoToBinary
} = svs.components.payment.createWager.utils;
const {
  splitBombenExpertenBoardDataToRows
} = svs.components.sport.expandedSystems;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  groupTypes
} = svs.components.marketplaceData.constants;
const {
  BOMBEN,
  MALTIPSET,
  FULLTRAFF,
  T8,
  T8EXTRA,
  T8STRYK,
  EUROPATIPSET,
  STRYKTIPSET,
  CHALLENGE,
  POWERPLAY
} = svs.utils.products.productIds;
const WEIGHTED_QUICK_PICK_VALUE = 'WEIGHTEDQP';
const getGroupType = type => {
  switch (type) {
    case WALLET_MARKETPLACE_PLAYER:
      return groupTypes.PRIVATE;
    case WALLET_MARKETPLACE_RETAILER:
      return groupTypes.RETAILER;
    default:
      logger.info("unsupported group type: ".concat(type));
  }
};


const createAndExecutePayment = async _ref => {
  let {
    bag,
    closeCallback,
    hasMarketplaceWallet,
    pixData,
    unlockPaymentFlow,
    wallet,
    wagerToPay
  } = _ref;
  let paymentBuilder;
  const _successCallback = () => {
    if (closeCallback) {
      closeCallback();
    }
    svs.components.sport.quickplayModal.hooks.unsetPixFromCache({
      pixData
    });
  };
  if (hasMarketplaceWallet) {
    const walletMeta = wallet === null || wallet === void 0 ? void 0 : wallet.meta;
    const role = getGroupType(wallet.type);
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    wagerToPay.setRole(role);
    if (isC2C) {
      wagerToPay.setActivatedDrawId(walletMeta.ActivatedDrawId);
    } else {
      wagerToPay.setActivatedDrawId(walletMeta.activatedDrawId);
      wagerToPay.setCommissionPercent(walletMeta.commissionPercent);
    }
    paymentBuilder = createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay],
      isC2C
    });
  } else {
    paymentBuilder = createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wagerToPay]
    });
  }
  const [, error] = await svs.components.wagerPaymentFlow.executePayment.executePayment(paymentBuilder, {
    userContext: {
      bag
    }
  });
  unlockPaymentFlow();
  if (!error) {
    _successCallback();
  }
};

const placeBetNewPaymentFlow = async _ref2 => {
  let {
    pixData,
    closeCallback,
    unlockPaymentFlow,
    wallet,
    rowPrice,
    subProductId
  } = _ref2;
  const {
    productId,
    systemCost
  } = pixData;
  const productName = getDisplayName(productId);
  if (!productName) {
    unlockPaymentFlow();
    logger.error("Error in placeBet: Invalid productId (".concat(productId, ")"));
    return;
  }

  const bag = "".concat(systemCost, ":").concat(productName, " ").concat(systemCost);
  const wagerToPay = createWagerToPay({
    pixData,
    rowPrice,
    subProductId
  });
  const wagerProductId = resolveITSProductId(productId) || '';
  if (!wagerProductId) {
    unlockPaymentFlow();
    logger.info('Warning in placeBetNewPaymentFlow: Sending wager without productID');
  }
  const hasMarketplaceWallet = isMarketplaceWallet(wallet);
  return createAndExecutePayment({
    bag,
    closeCallback,
    pixData,
    hasMarketplaceWallet,
    unlockPaymentFlow,
    wallet,
    wagerToPay
  });
};

const createWagerToPay = _ref3 => {
  let {
    pixData,
    rowPrice = 1,
    subProductId = undefined
  } = _ref3;
  const {
    drawNumber,
    productId,
    wagerBoardData
  } = pixData;
  const wager = createWager().addBet(productId, bet => {
    bet.setDrawNumber(drawNumber);
    bet.setRowPrice(rowPrice);
    if (subProductId) {
      bet.setSubProductId(subProductId);
    }
    switch (productId) {
      case BOMBEN:
        {
          const boardData = wagerBoardData.bomben;
          bet.addBetProperty(Bet.BetProperties.XPERTEN);
          const rows = splitBombenExpertenBoardDataToRows(boardData);
          rows.forEach(row => {
            const singleRow = [];
            while (row.length > 0) {
              const eventSigns = row.splice(0, 2);
              singleRow.push(eventSigns);
            }
            if (row.length === 0) {
              bet.addBoard(board => {
                singleRow.forEach(eventSigns => board.addOutcomes([eventSigns[0]], [eventSigns[1]]));
              });
            }
          });
          break;
        }
      case FULLTRAFF:
        {
          const boardData = wagerBoardData.fulltraff;
          bet.addBoard(board => {
            boardData.forEach(group => board.addOutcomes(group.map(value => parseInt(value, 10))).addBoardProperty(WEIGHTED_QUICK_PICK_VALUE));
          });
          break;
        }
      case EUROPATIPSET:
      case STRYKTIPSET:
      case POWERPLAY:
      case CHALLENGE:
      case T8:
      case T8EXTRA:
      case T8STRYK:
        {
          const boardData = wagerBoardData.game1X2;
          bet.addBoard(board => {
            boardData.forEach(row => board.addOutcomes(oneXTwoToBinary(row)).addBoardProperty(WEIGHTED_QUICK_PICK_VALUE));
          });
          break;
        }
      case MALTIPSET:
        {
          const boardData = wagerBoardData.maltipset;
          boardData.forEach(group => {
            bet.addBoard(board => board.addOutcomes(group.boardData).addBoardProperty(WEIGHTED_QUICK_PICK_VALUE));
          });
          break;
        }
      default:
        {
          logger.info("unsupported productId(".concat(productId, ") when creating wager"));
        }
    }
  });
  return wager;
};
setGlobal('svs.components.sport.quickplayModal.placeBetNewPaymentFlow', placeBetNewPaymentFlow);

 })(window);